<template>
  <a-modal
    title="정보 수정"
    v-model="$store.state.auth.editing"
    okText="수정"
    cancelText="취소"
    @ok="onUpdate"
  >
    <a-spin tip="로딩 중..." :spinning="isLoading">
      <a-divider orientation="left">사용자 정보</a-divider>

      <a-form-item
        label="이름:"
        :validate-status="details.username ? 'error' : ''"
        :help="details.username"
      >
        <a-input v-model="account.username" />
      </a-form-item>

      <a-form-item
        label="전화번호:"
        :validate-status="details.phone ? 'error' : ''"
        :help="details.phone"
      >
        <a-input v-model="account.phone" @change="getMask('phone')" />
      </a-form-item>

      <a-form-item
        label="이메일:"
        :validate-status="details.email ? 'error' : ''"
        :help="details.email"
      >
        <a-input v-model="account.email" />
      </a-form-item>

      <a-divider orientation="left">비밀번호 변경</a-divider>

      <a-form-item
        label="현재 비밀번호:"
        :validate-status="details.passwordCurrent ? 'error' : ''"
        :help="details.passwordCurrent"
      >
        <a-input-password v-model="account.passwordCurrent" />
      </a-form-item>

      <a-form-item
        label="새 비밀번호:"
        :validate-status="details.password ? 'error' : ''"
        :help="details.password"
      >
        <a-input-password v-model="account.password" />
      </a-form-item>

      <a-form-item
        label="비밀번호 재입력:"
        :validate-status="details.passwordConfirm ? 'error' : ''"
        :help="details.passwordConfirm"
      >
        <a-input-password v-model="account.passwordConfirm" />
      </a-form-item>

      <a-divider orientation="left">사업자 정보</a-divider>
      <a-form-item
        label="사업자 이름:"
        :validate-status="details.business.name ? 'error' : ''"
        :help="details.business.name"
      >
        <a-input v-model="account.business.name" />
      </a-form-item>

      <a-form-item
        label="사업자 전화번호:"
        :validate-status="details.business.phone ? 'error' : ''"
        :help="details.business.phone"
      >
        <a-input v-model="account.business.phone" @change="getBusinessMask('phone')" />
      </a-form-item>

      <a-form-item
        label="사업장 주소:"
        :validate-status="details.business.address ? 'error' : ''"
        :help="details.business.address"
      >
        <a-input v-model="account.business.address" />
      </a-form-item>

      <a-form-item
        label="홈페이지:"
        :validate-status="details.business.homepage ? 'error' : ''"
        :help="details.business.homepage"
      >
        <a-input v-model="account.business.homepage" />
      </a-form-item>
    </a-spin>
  </a-modal>
</template>
<script>
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
import { mapActions } from "vuex";

export default {
  name: "UserUpdate",
  data() {
    this.getInfo();
    return {
      isLoading: false,
      account: {
        username: "",
        phone: "",
        email: "",
        business: {
          name: "",
          phone: "",
          address: "",
          homepage: ""
        },
        password: "",
        passwordConfirm: "",
        passwordCurrent: ""
      },
      details: { business: {} }
    };
  },
  methods: {
    ...mapActions(["refreshMe"]),
    async getInfo() {
      try {
        this.isLoading = true;
        const { data } = await Axios.get(`${config.hostname}/v1/auth/update`, {
          withCredentials: true
        });

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.account = data.account;
              break;
            default:
              this.$store.state.auth.editing = false;
              config.alert.mixin({
                title: "정보를 가져올 수 없습니다.",
                type: "error"
              });
              break;
          }
        }
      } catch (err) {
        this.$store.state.auth.editing = false;
        config.alert.mixin({
          title: "사용자 정보를 불러올 수 없습니다.",
          type: "error"
        });
      }
      this.isLoading = false;
    },
    async onUpdate() {
      try {
        this.isLoading = true;
        this.details = { business: {} };
        const { data } = await Axios.post(
          `${config.hostname}/v1/auth/update`,
          this.account,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.$store.state.auth.editing = false;
              this.refreshMe();
              config.alert.mixin({
                title: "성공적으로 사용자 정보가 저장되었습니다.",
                type: "success"
              });
              break;
            case OPCODE.INVALID:
              this.details = Object.assign({ business: {} }, data.details);
              config.alert.mixin({
                title: "오류를 확인해주세요.",
                type: "error"
              });
              break;
            default:
              config.alert.mixin({
                title: "사용자 정보를 저장할 수 없습니다.",
                type: "error"
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          title: "오류로 인해 저장할 수 없습니다.",
          type: "error"
        });
      }
      this.isLoading = false;
    },
    getMask(type) {
      let num = this.account[type].replace(/[^0-9]/g, "");

      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      this.account[type] = res;
    },
    getBusinessMask(type) {
      let num = this.account.business[type].replace(/[^0-9]/g, "");

      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      this.account.business[type] = res;
    }
  }
};
</script>